kombi.deltaPricing = {
    calculate: function (containerSelector) {
        const container = document.querySelector(containerSelector);

        if (!container) {
            return;
        }

        const items = container.querySelectorAll("[data-delta-total]");

        if (!items.length) {
            return;
        }

        const highlightedItem = container.querySelector("[data-delta-highlighted]");
        let baseTotal = null;

        if (highlightedItem) {
            baseTotal = kombi.deltaPricing.parse(
                highlightedItem.getAttribute("data-delta-total")
            );
        }

        if (baseTotal === null) {
            const baselineAttr = container.getAttribute("data-delta-selection-baseline");

            if (baselineAttr) {
                baseTotal = kombi.deltaPricing.parse(baselineAttr);
            }
        }

        if (baseTotal === null) {
            baseTotal = kombi.deltaPricing.parse(
                items[0].getAttribute("data-delta-total")
            );
        }

        if (baseTotal === null) {
            return;
        }

        items.forEach(function (item) {
            const total = kombi.deltaPricing.parse(item.getAttribute("data-delta-total"));

            if (total === null) {
                return;
            }

            const delta = total - baseTotal;

            item.querySelectorAll(".js-delta-price").forEach(function (element) {
                element.textContent = kombi.deltaPricing.formatDelta(delta);
            });

            item.querySelectorAll(".js-delta-total").forEach(function (element) {
                element.textContent = "Total R$ " + kombi.deltaPricing.format(total);
            });
        });
    },

    parse: function (value) {
        if (value === undefined || value === null) {
            return null;
        }

        const raw = String(value).trim();

        if (raw === "" || raw.toLowerCase() === "nan") {
            return null;
        }

        if (/^-?\d+(\.\d+)?$/.test(raw)) {
            const direct = parseFloat(raw);

            return Number.isNaN(direct) ? null : direct;
        }

        if (raw.includes(",")) {
            const normalized = raw.replace(/\./g, "").replace(",", ".");
            const n = parseFloat(normalized);

            return Number.isNaN(n) ? null : n;
        }

        const fallback = parseFloat(raw.replace(/\s/g, ""));

        return Number.isNaN(fallback) ? null : fallback;
    },

    format: function (value) {
        return new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    },

    formatDelta: function (value) {
        const prefix = value < 0 ? "- R$ " : "+ R$ ";

        if (Math.abs(value) === 0) {
            return prefix + "0";
        }

        return prefix + kombi.deltaPricing.format(Math.abs(value));
    },
};
